// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2v9WB","footer":"ModalFilter_footer__2cjrZ"};